import { render, staticRenderFns } from "./MatchTypeChoice.vue?vue&type=template&id=c0b4f83e&scoped=true&"
import script from "./MatchTypeChoice.vue?vue&type=script&lang=js&"
export * from "./MatchTypeChoice.vue?vue&type=script&lang=js&"
import style0 from "./MatchTypeChoice.vue?vue&type=style&index=0&id=c0b4f83e&prod&lang=css&"
import style1 from "./MatchTypeChoice.vue?vue&type=style&index=1&id=c0b4f83e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4f83e",
  null
  
)

export default component.exports